import { BaseEntity } from '@smartera/core';

export interface ReportDemandDetail extends BaseEntity {
	demandExplanation: string;
	demandId: string;
	operationType: ReportDemandDetailOperationType;
	userProfileId: string;
	widgetId: string;
	widgetName: string;
}

export class ReportDemandDetailCreateDTO {
	demandDetailList: ReportDemandDetailInfo[];
	demandId: string;
}

export interface ReportDemandDetailInfo {
	demandId: string;
	operationType: ReportDemandDetailOperationType;
	userProfileId: string;
	widgetId: string;
}

export enum ReportDemandDetailOperationType {
	ADD = 'ADD',
	REMOVE = 'REMOVE',
}
